import { t } from 'i18next'
import { setShowModalCustomText } from '@/store/slices/modal/customTextModal'

export type TextModalKey =
  | 'PROJECT_STILL_SYNC'
  | 'PROJECT_CONFLICT'
  | 'PROJECT_DOESNT_EXIST'
  | 'PROJECT_NOT_SUPPORT'
  | 'NSFW_ERROR'
  | 'AI_IMAGE_ERROR'
  | 'AI_LIMIT'
  | 'AI_LIMIT_SUPER'
  | 'AI_CREDITS_RUNNING_LOW'

interface TextModalConfig {
  header: (vars?: Record<string, string>) => string
  text: (vars?: Record<string, string>) => string
  primaryButtonText: (vars?: Record<string, string>) => string
  secondaryButtonText?: () => string
  showSecondaryButton?: boolean
  primaryButtonVariant?: 'default' | 'gradient'
}

const TEXT_MODAL_CONFIGS: Record<TextModalKey, TextModalConfig> = {
  PROJECT_STILL_SYNC: {
    header: () => t('Project is still syncing'),
    text: () => t('Hang tight and try opening it in a moment.'),
    primaryButtonText: () => t('Ok'),
  },
  PROJECT_CONFLICT: {
    header: () => t('Can’t open this project'),
    text: () => t('The project is conflicted with other versions.'),
    primaryButtonText: () => t('Ok'),
  },
  PROJECT_DOESNT_EXIST: {
    header: () => t('Can’t open this project'),
    text: () => t("This project isn't available at this time."),
    primaryButtonText: () => t('Ok'),
  },
  PROJECT_NOT_SUPPORT: {
    header: () => t('Can’t open this project'),
    text: () =>
      t(
        'Some features of this project are currently not supported on Bazaart web. You can still edit it on your mobile device.'
      ),
    primaryButtonText: () => t('Ok'),
  },
  NSFW_ERROR: {
    header: () => t('Content not allowed'),
    text: () => t('Sorry, we can’t create that. Please try something else.'),
    primaryButtonText: () => t('OK'),
  },
  AI_IMAGE_ERROR: {
    header: () => t('Uh-oh!') + ' 😬',
    text: () => t('Something went wrong. Please try again.'),
    primaryButtonText: () => t('OK'),
  },
  AI_LIMIT: {
    header: () => t('AI credit limit reached'),
    text: ({ date } = {}) => t("You've used all your AI credits for this month. They'll reset on {{date}}.", { date }),
    primaryButtonText: () => t('Upgrade to Super'),
    secondaryButtonText: () => t('Not now'),
    showSecondaryButton: true,
    primaryButtonVariant: 'gradient',
  },
  AI_LIMIT_SUPER: {
    header: () => t('AI credit limit reached'),
    text: ({ date } = {}) => t("You've used all your AI credits for this month. They'll reset on {{date}}.", { date }),
    primaryButtonText: () => t('OK'),
  },
  AI_CREDITS_RUNNING_LOW: {
    header: () => t('Running low on AI credits'),
    text: ({ date } = {}) => t("You have 20% of this month’s AI credits left. They reset on {{date}}.", { date }),
    primaryButtonText: () => t('Upgrade to Super'),
    secondaryButtonText: () => t('Not now'),
    showSecondaryButton: true,
    primaryButtonVariant: 'gradient',
  }
}

export function showTextModal(
  key: TextModalKey,
  options?: {
    vars?: Record<string, string>
    onPrimary?: () => void
    onSecondary?: () => void
  }
): void {
  const config = TEXT_MODAL_CONFIGS[key]
  setShowModalCustomText(
    config.header(options?.vars),
    config.text(options?.vars),
    config.primaryButtonText(options?.vars),
    config.secondaryButtonText?.() ?? null,
    config.showSecondaryButton ?? false,
    options?.onPrimary,
    options?.onSecondary,
    config.primaryButtonVariant,
  )
}
